import * as Yup from 'yup';

/**
 * Generate initial values based in init or fieldsConf. If init is not specified, the zero
 * values for every type would be getted from fieldsConf
 * @param {json} fieldsConf
 * @param {json} init 
 * @returns 
 */
const generateInitialValues = (fieldsConf, init = {}) => {
  let initialvalues = {};
  let zeroValue;
  let initDefinido = Object.keys(init) !== 0;

  for (let key in fieldsConf) {
    if (initDefinido) { // init specified.
      zeroValue = init[fieldsConf[key].id];
    } else {
      zeroValue = fieldsConf[key].zeroValue;
    }
    initialvalues[fieldsConf[key].id] = zeroValue;
  }

  return initialvalues;
}


/**
 * Generate validation schema from validations field (in case that it exists) for every
 * field defined by fieldsConf.
 * @param {json} fieldsConf
 * @param {json} lang
 * @returns 
 */
const generateValidationSchema = (fieldsConf, lang) => {
  let validationSchema = {};
  let validationObject;
  let firstValidation = true;

  for (let key in fieldsConf) {
    // El campo no posee validaciones.
    if (fieldsConf[key].validations === undefined) continue;
    firstValidation = true;

    fieldsConf[key].validations.forEach((validation) => {
      if (firstValidation) {
        validationObject = Yup[validation.type](...validation.params);
        firstValidation = false;
      } else {
        validationObject = validationObject[validation.type](...validation.params);
      }
    })

    if (fieldsConf[key].required) validationObject = validationObject["required"](lang.book.validation.required);

    validationSchema[fieldsConf[key].id] = validationObject;
  }

  validationSchema = Yup.object().shape(validationSchema);
  return validationSchema;
}

export { generateInitialValues, generateValidationSchema }